import { ElementRef, Component, OnDestroy, AfterViewInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  KendoColumnListDefinition,
  TransactionVolumeModel,
  ChartModel,
  PortfolioPerformanceDetailsModel,
} from "../../insa-models";
import { InsaService, LocalizeService } from "../../insa-services";

import { appStateProvider } from "../../insa-providers";
import {
  SharedMethodsModule,
  GenericChartsModule,
} from "../../insa-custom-scripts";
import { appConfig } from "../../../insaweb.config";
import { Subscription } from "rxjs";

@Component({
  templateUrl: "home.component.html",
  styles: [
    `
      /* these styles fix overflow issues. - Filip */
      @media (max-width: 990px) {
        :host {
          overflow: visible !important;
        }
        #home#home {
          height: auto;
        }
      }
      :host {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        height: 100%;
        overflow: hidden;
      }
      #home {
        flex-grow: 1;
        height: 100%;
      }
      .card-container {
        height: 50% !important;
        display: flex;
        flex-direction: column;
        max-height: 50vh;
      }
      svg {
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class HomeComponent implements OnDestroy, AfterViewInit {
  private transVolumeSubscription: Subscription;
  private appStateSubscription: Subscription;
  private portfPerfDetailsSubscription: Subscription;
  private performanceDetailsChartSubscription: Subscription;
  private performanceSecondSerieDescription: string;
  private scroll: string;
  private cardStyleIE: string;
  private hasPartnerOrPortfolio: boolean = false;

  constructor(
    private router: Router,
    private _insaService: InsaService,
    private _appStateProvider: appStateProvider,
    private _localize: LocalizeService,
    private _element: ElementRef,
    private route: ActivatedRoute,
  ) {
    this.checkBrowserVersion();
    this.appStateSubscription = this._appStateProvider.subscribe(() => {
      this.setHasPartner();
    });
    this.transVolumeSubscription =
      this._insaService.TransactionsVolumeChangedEvent.subscribe(
        (transVolume) => this.refreshTransVolume(transVolume),
      );
    this.portfPerfDetailsSubscription =
      this._insaService.PortfolioPerformanceDetailsEvent.subscribe(
        (portfDetails) => this.refreshPortfDetails(portfDetails),
      );
    this.performanceDetailsChartSubscription =
      this._insaService.PerformanceDetailsChartEvent.subscribe((perfDetails) =>
        this.refreshPerfDetailsBarChart(perfDetails),
      );
    this.setHasPartner();
  }

  getDropdownValue(dropDownControlName: string) {
    let dropdown: kendo.ui.DropDownList =
      $(dropDownControlName).data("kendoDropDownList");
    let value: number = +dropdown.value();
    let text = dropdown.text();
    return { value, text };
  }

  private setHasPartner() {
    if (
      this._appStateProvider.selectedPartner.value !== 0 ||
      (this._appStateProvider.selectedPortfolios &&
        this._appStateProvider.selectedPortfolios.length > 0)
    ) {
      this.hasPartnerOrPortfolio = true;
    } else {
      this.hasPartnerOrPortfolio = false;
    }
  }

  private checkBrowserVersion() {
    let ua = window.navigator.userAgent;
    //for IE 11
    let ie11 = ua.indexOf("rv");
    //for IE9++
    let msie = ua.indexOf("MSIE");
    //for MS Edge
    let edge = ua.indexOf("Edge");
    let ieVer: number;

    if (ie11 > 0) {
      ieVer = parseInt(ua.substring(ie11 + 3, ua.indexOf(".", ie11)), 10);
    }
    if (msie > 0) {
      ieVer = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
    }
    if (ieVer >= 7 && ieVer < 13) {
      this.scroll = "scroll";
      this.cardStyleIE = "45vh";
    }
    if (edge > -1) {
      this.scroll = "scroll";
      this.cardStyleIE = "45vh";
    }
  }

  private refreshTransVolume(transVolume: TransactionVolumeModel[]) {
    if (
      transVolume !== undefined &&
      transVolume !== null &&
      transVolume.length > 0
    ) {
      this.KendoTransactionVolumeList(
        "#TransactionVolume",
        transVolume,
        this.createTransVolumeList(),
      );
    } else {
      this.KendoTransactionVolumeList("#TransactionVolume", [], []);
    }
  }

  private refreshPortfDetails(
    portfDetails: PortfolioPerformanceDetailsModel[],
  ) {
    if (portfDetails !== undefined && portfDetails.length > 0) {
      this.KendoInitAccordion(
        SharedMethodsModule.groupBy(portfDetails, "Element", "Amount"),
      );
      $("#portfMessage").html("");
    } else {
      this.KendoInitAccordion(
        SharedMethodsModule.groupBy([], "Element", "Amount"),
      );
      $("#portfMessage").html('<p class="center no-data-message">NO DATA</p>');
    }
  }

  private refreshPerfDetailsBarChart(perfDetails: ChartModel[]) {
    if (perfDetails !== undefined && perfDetails.length > 0) {
      let carouselOpt: CarouselOptions = {};
      carouselOpt.interval = appConfig.setCarouselTimeout;
      GenericChartsModule.KendoGenericChartList(
        "#PerformanceDetailsList",
        perfDetails,
        this.createPerformanceDetailsList(),
      );
      this.hidePerformanceColumn();
      $("#performanceCarousel").carousel(carouselOpt);
    } else {
      GenericChartsModule.KendoGenericChartList(
        "#PerformanceDetailsList",
        [],
        [],
      );
    }
  }

  private hidePerformanceColumn() {
    let perfList: kendo.ui.Grid = $("#PerformanceDetailsList").data(
      "kendoGrid",
    );
    if (perfList !== undefined) {
      if (
        window.innerWidth < 1200 &&
        appConfig.hidePerformanceChartListColumn
      ) {
        perfList.hideColumn(2);
      } else {
        perfList.showColumn(2);
      }
    }
  }

  private goToCharts() {
    this.router.navigate(["/charts"]);
  }

  private goToPerformance() {
    this.router.navigate(["/performance"]);
  }

  private goToTransactions() {
    this.router.navigate(["/transactions"]);
  }

  private goToPortfolio() {
    this.router.navigate(["/portfolio"]);
  }

  private goToNews() {
    this.router.navigate(["/news"]);
  }

  private goToCrossRates() {
    this.router.navigate(["/crossRates"]);
  }

  private KendoInitAccordion(groupedData) {
    $("#accordion").empty();
    let listViewOptions: kendo.ui.ListViewOptions = {};
    listViewOptions.dataSource = groupedData;
    listViewOptions.template = kendo.template(
      `<div class ="accordion">
        <span>
        <ul class="portfolio">
        <li>#: Name#</li>
        <li class="text-right">#: kendo.toString(Amount, 'n2')#</li>
        </ul>
        </span>
        <div>#for(var x=0; x < SubItems.length; x++){#
        <ul class="portfolio">
        <li class="col-indent">#: (SubItems[x].Name!=="") ? SubItems[x].Name : "-" #</li>
        <li class="text-right deep"> #: kendo.toString(SubItems[x].Amount, 'n2')#</li>
        </ul>
        #}#</div>
        </div>`,
    );
    listViewOptions.dataBound = function (e) {
      let panelBarOptions: kendo.ui.PanelBarOptions = {};
      panelBarOptions.expandMode = "multiple";
      $(".k-listview-content").kendoPanelBar(panelBarOptions);
    };
    $("#accordion").kendoListView(listViewOptions);
  }
  // $("#panelbar").kendoPanelBar({
  //     expandMode: "full"
  // });

  // <script>
  //     $(document).ready(function() {
  //                 $("#panelbar").kendoPanelBar({
  //                     expandMode: "single"
  //                 });
  //             });
  //  </script>

  private KendoTransactionVolumeList(selector, listData, columnDef) {
    let transVolumeOptions: kendo.ui.GridOptions = {};
    transVolumeOptions.dataSource = listData;
    transVolumeOptions.columns = columnDef;
    transVolumeOptions.scrollable = true;
    transVolumeOptions.resizable = true;
    transVolumeOptions.noRecords = {
      template:
        "<div class='center no-data-message'><img src='../../images/nodata.svg' style='width:150px;height:150px'/><p class='transactions-card-no-data' style='color:black';>NO DATA</p></div>",
    };
    $(selector).kendoGrid(transVolumeOptions);
  }

  private createPerformanceDetailsList() {
    let performanceColumnDefs = new Array<KendoColumnListDefinition>();
    performanceColumnDefs.push(
      new KendoColumnListDefinition(
        "Date",
        '#: kendo.toString(Date, "dd.MM.yyyy")#',
        {},
        "",
        "Date",
      ),
    );
    performanceColumnDefs.push(
      new KendoColumnListDefinition(
        "Value",
        '#: kendo.toString(Value, "n2")  + "%" #',
        { style: "text-align: right;" },
        "",
        "Performance",
        { style: "text-align: right;" },
      ),
    );
    performanceColumnDefs.push(
      new KendoColumnListDefinition(
        "Value2",
        '#: kendo.toString(Value2, "n2")  + "%" #',
        { style: "text-align: right;" },
        "",
        appConfig.performanceChartSecondSerieName === ""
          ? this._localize.getLocalizedResource("Res2271")
          : appConfig.performanceChartSecondSerieName,
        { style: "text-align: right;" },
      ),
    );
    return performanceColumnDefs;
  }

  private createTransVolumeList() {
    let transVolumeColDef = new Array<KendoColumnListDefinition>();
    transVolumeColDef.push(
      new KendoColumnListDefinition(
        "TransDescription",
        '#: (TransDescription!==null) ? TransDescription: "-" #',
        { style: "font-weight:300;" },
        "",
        this._localize.getLocalizedResource("Res542"),
      ),
    );
    transVolumeColDef.push(
      new KendoColumnListDefinition(
        "Amount",
        "#: kendo.toString(Amount, 'n2') #",
        { style: "text-align: right; font-weight: 300;" },
        "",
        this._localize.getLocalizedResource("Res2172"),
        { style: "text-align: right;" },
      ),
    );
    return transVolumeColDef;
  }

  ngAfterViewInit() {
    this._localize.applyTranslations(this._element.nativeElement);
    kendo.ui.progress(
      $(".portfList-loading"),
      this._appStateProvider.fetchingPortfolioDetails,
    );
    kendo.ui.progress(
      $(".transList-loading"),
      this._appStateProvider.fetchingTransVolume,
    );
    this.refreshPerfDetailsBarChart(
      this._insaService.chartDataPerformanceDetails,
    );
    this.refreshTransVolume(this._insaService.transactionVolume);
    this.refreshPortfDetails(this._insaService.portfolioPerformanceDetails);
    this.hidePerformanceColumn();
  }

  ngOnInit() {
    document.getElementById("content").classList.add("flex-override"); // fixes vertical overflow issue

    this.route.queryParamMap.subscribe((params) => {
      //this.pageNo = +params.get('pageNum')||0;
      //let routeSnapshot = this.route.snapshot;
      if (params.has("PartnerID")) {
        this._appStateProvider.selectedPartner = {
          value: Number.parseInt(params.get("PartnerID")),
          text: "Self",
        };
      }
      if (params.has("portfolios")) {
        var array = params.get("portfolios").split(",");
        var intArray = new Array<any>();
        params
          .get("portfolios")
          .split(",")
          .map((portf) => {
            intArray.push(Number.parseInt(portf));
          });
        this._appStateProvider.selectedPortfolios = intArray;
      }
      if (params.has("fromDate")) {
        this._appStateProvider.startDate = new Date(params.get("fromDate"));
      }
      if (params.has("toDate")) {
        this._appStateProvider.endDate = new Date(params.get("toDate"));
      }
      if (params.has("currencyIndex")) {
        this._appStateProvider.selectedCurrency = {
          value: Number.parseInt(params.get("currencyIndex")),
          text: "",
        }; // this.getDropdownValue("#currency");
        this._appStateProvider.emit(
          "Triggered data fetching from home component - by URL navigation!",
        );
      }
    });
    // subscribe to the parameters observable
  }

  ngOnDestroy() {
    document.getElementById("content").classList.remove("flex-override"); // fixes vertical overflow issue

    this.appStateSubscription.unsubscribe();
    this.transVolumeSubscription.unsubscribe();
    this.portfPerfDetailsSubscription.unsubscribe();
    this.performanceDetailsChartSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-home/home.component.ts